import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import Auth from "./pages/Auth";
import Search from "./pages/Search";
import ParkingSpotDetail from "./pages/ParkingSpotDetail";
import Dashboard from "./pages/Dashboard";
import CreateListing from "./pages/CreateListing";
import NotFound from "./pages/NotFound";
import Book from "@/pages/Book";
import Success from "@/pages/Success";
import Favorites from "@/pages/Favorites";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import TermsOfService from "@/pages/TermsOfService";
import Profile from "@/pages/Profile";
import ResetPassword from "@/pages/ResetPassword";
import Contact from "@/pages/Contact";
import Admin from "@/pages/Admin";
import FAQ from "@/pages/FAQ";
import CityParking from "@/pages/CityParking";
import { CookieConsent } from "@/components/CookieConsent";
import { useEffect } from "react";
import { initGA, trackPageView } from "@/lib/analytics";
import { errorTracker } from "@/lib/errorTracking";
import { useLocation } from "react-router-dom";

const queryClient = new QueryClient();

export default function App() {
  const location = useLocation();

  useEffect(() => {
    // Initialize error tracking
    errorTracker.init();

    // Initialize Google Analytics (replace with your GA4 Measurement ID)
    // You can get this from Google Analytics: https://analytics.google.com
    // Format: G-XXXXXXXXXX
    const GA_MEASUREMENT_ID = ""; // TODO: Add your GA4 Measurement ID here
    
    if (GA_MEASUREMENT_ID && localStorage.getItem("cookieConsent") === "all") {
      initGA(GA_MEASUREMENT_ID);
    }
  }, []);

  // Track page views
  useEffect(() => {
    if (localStorage.getItem("cookieConsent") === "all") {
      trackPageView(location.pathname + location.search);
    }
  }, [location]);

  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <CookieConsent />
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/auth" element={<Auth />} />
          <Route path="/search" element={<Search />} />
          <Route path="/spot/:id" element={<ParkingSpotDetail />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/create-listing" element={<CreateListing />} />
          <Route path="/book/:id" element={<Book />} />
          <Route path="/success" element={<Success />} />
          <Route path="/favorites" element={<Favorites />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/parkering-koebenhavn" element={<CityParking />} />
          <Route path="/parkering-aarhus" element={<CityParking />} />
          <Route path="/parkering-odense" element={<CityParking />} />
          <Route path="/admin" element={<Admin />} />
          {/* CATCH-ALL skal til sidst */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </TooltipProvider>
    </QueryClientProvider>
  );
}
